var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrandShapes1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 132 132",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M132 86.327V26.6168L107.949 2.65841C106.238 0.957289 103.923 0 101.511 0H27.0821C18.9468 0 14.8807 9.84316 20.6446 15.5836L88.9897 83.6686C90.6975 85.3697 93.0124 86.327 95.4273 86.327H132Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 113.429V113.431C0.000245854 115.677 0.835899 117.967 2.70266 119.826L14.924 132H115.206L90.0103 106.901C88.2992 105.196 85.9844 104.239 83.5694 104.242H9.14024C3.6405 104.242 0.00051316 108.741 0 113.429Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandShapes1);
export default __webpack_public_path__ + "static/media/BrandShapes1.bec06e5ca5e9e7dfe88e7706f755b4ac.svg";
export { ForwardRef as ReactComponent };